import type { BBInheritanceParent, ComponentAITemplate, SelectedBBSingle } from 'types/story';
import { COMPONENT_TYPE } from 'common/constants';
import { canHaveChildren } from 'common/utils/blocks/features';
import { PROMPT_TYPE_OPTIONS } from './constants';

export const getParentAITemplateValue = (parent: BBInheritanceParent) => {
	return parent.inheritance.componentProps?.aiTemplate?.at(-1)?.value as ComponentAITemplate | undefined | null;
};

// Get available AI template types based on component type
export function getAvailableTypes(element: SelectedBBSingle): ComponentAITemplate['type'][] {
	const { type: componentType } = element;

	if (canHaveChildren(element)) {
		return ['group'];
	}

	switch (componentType) {
		case COMPONENT_TYPE.TEXT:
			return ['text'];
		case COMPONENT_TYPE.IMG:
		case COMPONENT_TYPE.CARD:
			return ['image'];
		default:
			return [];
	}
}

// Get default AI prompt type based on component type
export function getDefaultType(element: SelectedBBSingle): ComponentAITemplate['type'] {
	const availableTypes = getAvailableTypes(element);
	return availableTypes[0];
}

// Create filtered options based on element type
export function getFilteredTypeOptions(element: SelectedBBSingle) {
	const availableTypes = getAvailableTypes(element);
	return PROMPT_TYPE_OPTIONS.filter(option => availableTypes.includes(option.value));
}
